import { render, staticRenderFns } from "./ModalEditarValidade.vue?vue&type=template&id=6e6d1b4a"
import script from "./ModalEditarValidade.vue?vue&type=script&lang=js"
export * from "./ModalEditarValidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports